import { Link } from "react-router-dom";
import { FaLinkedin, FaTwitter, FaFacebook, FaInstagram, FaPhone, FaEnvelope, FaMapMarkerAlt, FaWhatsapp } from "react-icons/fa";
import { serviceCategories } from "../../data/services";
import { contactInfo } from "../../data/content";

const quickLinks = [
  { label: "Home", path: "/" },
  { label: "About Us", path: "/about" },
  { label: "Services", path: "/services" },
  { label: "Industries", path: "/industries" },
  { label: "Contact", path: "/contact" },
];

const socials = [
  { Icon: FaLinkedin, url: "https://linkedin.com", label: "LinkedIn" },
  { Icon: FaTwitter, url: "https://twitter.com", label: "Twitter" },
  { Icon: FaFacebook, url: "https://facebook.com", label: "Facebook" },
  { Icon: FaInstagram, url: "https://instagram.com", label: "Instagram" },
];

export default function Footer() {
  const year = new Date().getFullYear();
  const topCategories = serviceCategories.slice(0, 5);

  return (
    <footer className="w-full bg-white text-gray-700" style={{ borderTop: '2px solid var(--color-border)' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 xl:px-10 py-16 lg:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">

          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-3 mb-4">
              <img
                src="/logo.png"
                alt="Finegal Tech Solution"
                className="w-full h-16 object-contain"
              />
            </Link>
            <p className="text-base leading-relaxed text-gray-500 mb-6">
              Your trusted partner in Finance, Legal, and Technology solutions. We simplify compliance so you can focus on growth.
            </p>
            <div className="flex gap-3">
              {socials.map(({ Icon, url, label }) => (
                <a
                  key={label}
                  href={url}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={label}
                  className="w-9 h-9 rounded-lg flex items-center justify-center transition-all duration-200 hover:opacity-80"
                  style={{ background: 'var(--color-primary)', color: '#fff' }}
                >
                  <Icon className="text-sm" />
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-bold mb-4 text-lg" style={{ color: 'var(--color-primary-dark)' }}>Quick Links</h3>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="text-base text-gray-500 hover:text-yellow-500 transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="font-bold mb-4 text-lg" style={{ color: 'var(--color-primary-dark)' }}>Our Services</h3>
            <ul className="space-y-2">
              {topCategories.map((cat) => (
                <li key={cat.id}>
                  <Link to={`/services#${cat.id}`} className="text-base text-gray-500 hover:text-yellow-500 transition-colors">
                    {cat.title}
                  </Link>
                </li>
              ))}
              <li>
                <Link to="/services" className="text-base font-semibold hover:opacity-80 transition-colors" style={{ color: 'var(--color-secondary)' }}>
                  View All Services →
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-bold mb-4 text-lg" style={{ color: 'var(--color-primary-dark)' }}>Contact Us</h3>
            <ul className="space-y-3 text-base">
              <li className="flex items-start gap-3 text-gray-500">
                <FaMapMarkerAlt className="mt-1 shrink-0" style={{ color: 'var(--color-secondary)' }} />
                <span>{contactInfo.address}</span>
              </li>
              <li>
                <a href={`tel:${contactInfo.phone}`} className="flex items-center gap-3 text-gray-500 hover:text-yellow-500 transition-colors">
                  <FaPhone className="shrink-0" style={{ color: 'var(--color-secondary)' }} /> {contactInfo.phone}
                </a>
              </li>
              <li>
                <a href={`mailto:${contactInfo.email}`} className="flex items-center gap-3 text-gray-500 hover:text-yellow-500 transition-colors">
                  <FaEnvelope className="shrink-0" style={{ color: 'var(--color-secondary)' }} /> {contactInfo.email}
                </a>
              </li>
              <li>
                <a
                  href={`https://wa.me/${contactInfo.whatsapp}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-semibold text-white mt-1 transition-opacity hover:opacity-90"
                  style={{ background: "#25D366" }}
                >
                  <FaWhatsapp className="text-base" /> Chat on WhatsApp
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="w-full py-5" style={{ background: 'var(--color-primary-dark)', borderTop: '1px solid var(--color-border)' }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 xl:px-10">
          <div className="flex flex-col md:flex-row justify-between items-center gap-2 text-sm" style={{ color: 'var(--color-text-inverse)' }}>
            <p>© {year} Finegal Tech Solution. All Rights Reserved.</p>
            <p className="mt-1">
              Designed &amp; Developed by{' '}
              <a
                href="https://leadsmagnet.in/"
                target="_blank"
                rel="noopener noreferrer"
                className="font-semibold hover:text-yellow-400 transition-colors"
                style={{ color: 'var(--color-secondary)' }}
              >
                LeadsMagnet Digital Marketing Pvt. Ltd.
              </a>
            </p>
            <div className="flex gap-4">
              <Link to="/privacy-policy" className="hover:text-yellow-400 transition-colors">Privacy Policy</Link>
              <Link to="/terms" className="hover:text-yellow-400 transition-colors">Terms of Service</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
